<div class="w-full">
  <!--BLUE BAR-->
  <div class="horiz-bar bg-primary"></div>
  <!--TITLE-->
  <div class="flex justify-content-between align-items-center flex-wrap mb-4 mt-4">
    <div class="flex justify-content-between align-items-center">
      <div class="text-800 text-3xl font-medium mr-4">{{ 'MYOPIA_TREATMENTS_TITLE' | translate }}</div>
    </div>
  </div>

  <!--ROW 1-->
  @for (item of treatmentCalcResponse.treatmentItems; track $index) {
  <div class="w-full">
    <div class="surface-card mb-2 p-4 border-round border-1 border-gray-300">
      <div class="flex flex-column gap-3">
        <!-- Treatment Name -->
        <div class="flex align-items-center justify-content-between">
          <div class="text-900 font-medium text-lg">{{ item.model.treatment.displayName}}</div>
          <div class="bg-primary-100 text-primary-700 text-sm px-3 py-1 border-round">
            {{item.model.treatment.treatmentType.displayName}}
          </div>
          <div class="flex align-items-center text-sm gap-2 text-600">
            <span>{{ item.model.startDate| date:'dd MMM yy' }}</span>
            <span>→</span>
            <span>{{ item.model.endDate ? (item.model.endDate | date:'dd MMM yy') : 'Ongoing' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
